import { render, staticRenderFns } from "./LogsApprovalSR.vue?vue&type=template&id=3af819de&scoped=true"
import script from "./LogsApprovalSR.vue?vue&type=script&lang=js"
export * from "./LogsApprovalSR.vue?vue&type=script&lang=js"
import style0 from "./LogsApprovalSR.vue?vue&type=style&index=0&id=3af819de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3af819de",
  null
  
)

export default component.exports